export { default as InfoTooltip } from './info-tooltip'
